<template>
    <div v-if="showModal" class="modal-mask">
        <div class="modal-container">
            <div class="modal-header">
                <h3>系统日结中</h3>
            </div>
            <div class="modal-body">
                <p class="body_one">尊敬的商户，系统正在执行每日日结（00:00-00:50）。</p>
                <p class="body_two">在此期间，昨日（{{ date }}）移动支付数据暂不可查。如需查昨日数据请待日结后再试，感谢您的理解与支持！</p>
            </div>
            <div class="modal-footer">
                <el-button type="primary" size="mini" @click="closeModal">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: {
        showModal: {
            type: Boolean,
            default: false,

        }
    },
    data() {
        return {
            date: moment().subtract(1, 'days').format('YYYY-MM-DD')
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-container {
    background: #fff;
    border-radius: 8px;
    width: 80%;
    max-width: 500px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}

.modal-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    padding: 20px;
    font-size: 16px;

    .body_one {
        margin-bottom: 10px;
    }
}

.modal-footer {
    padding: 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

.close {
    cursor: pointer;
    font-size: 20px;
}
</style>